import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change, reset } from 'redux-form'
import { Icon, Input, Button } from 'semantic-ui-react'
import { Collapse } from '@material-ui/core'
import moment from 'moment'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getCompanyOptions, getVendorOptions, exportBGData } from 'ducks/bankGuarantee'
import { getCompanyOptionsBGR, getVendorOptionsBGR } from 'ducks/bankGuaranteeRequest'
import { SearchCont, InputCont, AdvanceCont } from './styled'
import { CustomButton } from 'components'
import { CSVLink } from 'react-csv'
import { exportColumn } from '../../AttributeData'

const SearchList = (props) => {
  const {
    valueForm={},
    change,
    companies,
    vendors,
    pageSize,
    formSearchName,
    fetchAPI,
    placeholder = '',
    multiCompany = false,
    bgType='report',
    showExportButton = false,
    bgExport,
  } = props

  const [visibleAS, setVisibleAS] = React.useState(false)

  React.useEffect(() => {
    if (bgType === 'report') {
      props.getCompanyOptions()
      props.getVendorOptions()
    } else {
      props.getCompanyOptionsBGR()
      props.getVendorOptionsBGR()
    }
  }, [])

  React.useEffect(() => {
    if (valueForm) {
      fetchAPI({ ...valueForm, page: 1, size: pageSize })
    }
  }, [valueForm.status, valueForm.companyCode, valueForm.vendorCode])

  function onResetClick() {
    change(formSearchName, 'key', '')
    change(formSearchName, 'status', '')
    change(formSearchName, 'companyCode', '')
    change(formSearchName, 'vendorCode', '')
  }

  function onAdvanceSearchClick(data) {
    if (valueForm) {
      fetchAPI({ ...props.valueForm, ...data, page: 1, size: pageSize })
    }
  }

  const statusReport = [
    { key: 0, value: '0', text: 'Draft' },
    { key: 1, value: '1', text: 'Active' },
    { key: 18, value: '18', text: 'Not Start' },
    { key: 20, value: '20', text: 'Expired' },
    { key: 19, value: '19', text: 'Changed' },
    { key: 21, value: '21', text: 'Returned' },
    { key: 6, value: '6', text: 'Cancelled' },
  ]

  const statusRequest = [
    { key: 0, value: '0', text: 'Draft' },
    { key: 3, value: '3', text: 'Revise' },
    { key: 5, value: '5', text: 'Reject' },
    { key: 22, value: '22', text: 'Approver Review' },
    { key: 23, value: '23', text: 'Account Officer Review' },
    { key: 24, value: '24', text: 'Account Manager Review' },
    { key: 25, value: '25', text: 'Finance Review' },
    { key: 26, value: '26', text: 'Finance Processing' },
    { key: 4, value: '4', text: 'Completed' },
    { key: 6, value: '6', text: 'Cancelled' },
  ]

  return (
    <SearchCont>
      <InputCont>
        <Field 
          name='key' 
          placeholder={placeholder} 
          onSearchClick={() => onAdvanceSearchClick()} 
          component={renderInputSearch} 
          onEnter={() => onAdvanceSearchClick()} />
        <Icon name='settings' circular inverted link onClick={() => setVisibleAS(!visibleAS)} />
      </InputCont>
      <Collapse in={visibleAS} timeout='auto' unmountOnExit>
        <AdvanceCont>
          <div style={{ display: 'flex', flex: '1', alignItems: 'center' }}>
            <Field
              name='status'
              label='Status'
              allowAdditions={false}
              options={bgType === 'report' ? statusReport : statusRequest}
              type={type.select}
              placeHolder='All Status'
              editable
              component={FieldInput}
            />
            <Field
              name='companyCode'
              label='Company'
              allowAdditions={false}
              loading={companies.loading}
              options={companies.data}
              placeHolder='All Company'
              editable
              type={multiCompany ? type.multiSelect : type.select}
              component={FieldInput}
            />
            <Field
              name='vendorCode'
              label='Vendor'
              allowAdditions={false}
              loading={vendors.loading}
              options={vendors.data}
              type={type.select}
              placeHolder='All Vendor'
              editable
              component={FieldInput}
            />
          </div>
        </AdvanceCont>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type='button' onClick={() => { reset(props.formSearchName); onResetClick() }}>Clear</Button>
          {
            showExportButton ?
            <React.Fragment>
              <CSVLink
                id='export_bg_link_id'
                data={bgExport.data}
                filename={`BG_Reports_${moment(new Date()).format('DDMMYYYY-HHmm')}.csv`}
                headers={exportColumn}
              ></CSVLink>
              <CustomButton
                onClick={() => {
                  props.exportBGData({ ...valueForm }, () => { 
                    var element = document.getElementById('export_bg_link_id')
                    if (element) element.click()
                  })
                  // const { key, companyCode, vendorCode, status } = valueForm
                  // const url = `${process.env.REACT_APP_API_PATH}${process.env.REACT_APP_API_VERSION}/exportFile/bankGuarantee?key=${key || ''}&companyCode=${companyCode || ''}&vendorCode=${vendorCode || ''}&status=${status || ''}&username=${user.username || ''}`
                  // window.open(url)  
                }}
                icon='download'
                btnColor='blue'
                title='Export Data' />
            </React.Fragment> : null
          }
        </div>
      </Collapse>
    </SearchCont>
  )
}

const renderInputSearch = props => {
  const { input, onSearchClick, placeholder } = props
  return (
    <Input
      {...input}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          props.onEnter()
        }
      }}
      className='searchInput'
      icon={<Icon type='button' name='search' inverted circular link onClick={onSearchClick} />}
      placeholder={placeholder} />
  )
}

const mapStateToProps = (state, props) => {
  return ({
    valueForm: getFormValues(props.formSearchName)(state),
    companies: props.bgType === 'report' ? state.bg.companyOptions : state.bgRequest.companyOptions,
    vendors: props.bgType === 'report' ? state.bg.vendorOptions : state.bgRequest.vendorOptions,
    bgExport: state.bg.bgExport
  })
}

const mapDispatchToProps = {
  change,
  reset,
  getCompanyOptions, 
  getVendorOptions,
  getCompanyOptionsBGR, 
  getVendorOptionsBGR,
  exportBGData,
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchList)
